import React from 'react';
import './TermsConditions.css';

const TermsConditions = () => {
  return (
    <div className="terms-conditions">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title fade-in">Terms and Conditions</h1>
          <p className="page-subtitle fade-in">Last updated: March 2, 2026</p>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="content-wrapper card fade-in">
            <section className="content-section">
              <h2>1. Agreement to Terms</h2>
              <p>
                These Terms and Conditions ("Terms") constitute a legally binding agreement between you 
                ("User," "you," or "your") and EnglishMaster ("Company," "we," "us," or "our") concerning 
                your access to and use of the EnglishMaster mobile application and website (collectively, 
                the "Service").
              </p>
              <p>
                By accessing or using the Service, you agree to be bound by these Terms. If you do not 
                agree with these Terms, you must not access or use the Service.
              </p>
            </section>

            <section className="content-section">
              <h2>2. Eligibility</h2>
              <p>
                You must be at least 13 years of age to use our Service. By using the Service, you 
                represent and warrant that:
              </p>
              <ul>
                <li>You are at least 13 years old</li>
                <li>You have the legal capacity to enter into these Terms</li>
                <li>You will not use the Service for any illegal or unauthorized purpose</li>
                <li>Your use of the Service will not violate any applicable law or regulation</li>
              </ul>
              <p>
                If you are under 18 years of age, you represent that your parent or legal guardian has 
                reviewed and agreed to these Terms on your behalf.
              </p>
            </section>

            <section className="content-section">
              <h2>3. Account Registration</h2>
              <h3>3.1 Account Creation</h3>
              <p>
                To access certain features of the Service, you must register for an account. When you 
                register, you agree to:
              </p>
              <ul>
                <li>Provide accurate, current, and complete information</li>
                <li>Maintain and promptly update your account information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
                <li>Accept responsibility for all activities that occur under your account</li>
              </ul>

              <h3>3.2 Account Security</h3>
              <p>
                You are responsible for maintaining the confidentiality of your account password and for 
                all activities that occur under your account. We reserve the right to suspend or terminate 
                your account if we suspect any unauthorized use or security breach.
              </p>
            </section>

            <section className="content-section">
              <h2>4. User Content</h2>
              <h3>4.1 Your Content</h3>
              <p>
                The Service may allow you to submit, post, or share content, including but not limited to 
                text, audio recordings, and progress data ("User Content"). You retain all rights to your 
                User Content.
              </p>
              <p>
                By submitting User Content, you grant us a worldwide, non-exclusive, royalty-free license 
                to use, reproduce, modify, adapt, publish, and display your User Content for the purpose 
                of providing and improving the Service.
              </p>

              <h3>4.2 Content Restrictions</h3>
              <p>You agree not to submit User Content that:</p>
              <ul>
                <li>Is illegal, harmful, threatening, abusive, harassing, or defamatory</li>
                <li>Infringes any intellectual property rights or other proprietary rights</li>
                <li>Contains viruses, malware, or other harmful code</li>
                <li>Violates any applicable law or regulation</li>
                <li>Is false, misleading, or fraudulent</li>
                <li>Impersonates any person or entity</li>
              </ul>
            </section>

            <section className="content-section">
              <h2>5. Subscription and Payment</h2>
              <h3>5.1 Subscription Plans</h3>
              <p>
                The Service offers both free and paid subscription plans. Paid subscriptions provide 
                access to premium features and content. Subscription fees are charged on a recurring basis 
                (monthly, quarterly, or annually) depending on the plan you select.
              </p>

              <h3>5.2 Payment Terms</h3>
              <ul>
                <li>Payment must be made through the payment methods we accept</li>
                <li>Subscription fees are non-refundable except as required by law</li>
                <li>We may change subscription fees with reasonable notice</li>
                <li>Your subscription will automatically renew unless cancelled</li>
                <li>You can cancel your subscription at any time from your account settings</li>
              </ul>

              <h3>5.3 Free Trial</h3>
              <p>
                We may offer a free trial period for certain subscription plans. If you do not cancel 
                before the trial period ends, you will be automatically charged for the subscription.
              </p>
            </section>

            <section className="content-section">
              <h2>6. Intellectual Property Rights</h2>
              <h3>6.1 Our Content</h3>
              <p>
                All content, features, and functionality on the Service, including but not limited to 
                text, graphics, logos, images, audio clips, video clips, data compilations, and software, 
                are owned by EnglishMaster or its licensors and are protected by copyright, trademark, 
                and other intellectual property laws.
              </p>

              <h3>6.2 Limited License</h3>
              <p>
                We grant you a limited, non-exclusive, non-transferable license to access and use the 
                Service for your personal, non-commercial use. This license does not include any right to:
              </p>
              <ul>
                <li>Modify, copy, distribute, or create derivative works</li>
                <li>Reverse engineer, decompile, or disassemble the Service</li>
                <li>Remove or alter any proprietary notices</li>
                <li>Use the Service for commercial purposes</li>
                <li>Transfer or sublicense your rights</li>
              </ul>
            </section>

            <section className="content-section">
              <h2>7. Prohibited Activities</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Service for any unlawful purpose or in violation of these Terms</li>
                <li>Impersonate any person or entity or misrepresent your affiliation</li>
                <li>Interfere with or disrupt the Service or servers or networks</li>
                <li>Attempt to gain unauthorized access to any portion of the Service</li>
                <li>Use any automated system to access the Service</li>
                <li>Collect or harvest any information from the Service</li>
                <li>Transmit any viruses, malware, or harmful code</li>
                <li>Violate any applicable laws or regulations</li>
              </ul>
            </section>

            <section className="content-section">
              <h2>8. Disclaimers and Limitations of Liability</h2>
              <h3>8.1 Service "As Is"</h3>
              <p>
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER 
                EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS 
                FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
              </p>

              <h3>8.2 Limitation of Liability</h3>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL ENGLISHMASTER BE LIABLE FOR ANY 
                INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS 
                OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, 
                OR OTHER INTANGIBLE LOSSES.
              </p>
            </section>

            <section className="content-section">
              <h2>9. Indemnification</h2>
              <p>
                You agree to indemnify, defend, and hold harmless EnglishMaster and its officers, 
                directors, employees, and agents from and against any claims, liabilities, damages, 
                losses, and expenses arising out of or in any way connected with:
              </p>
              <ul>
                <li>Your access to or use of the Service</li>
                <li>Your violation of these Terms</li>
                <li>Your violation of any third-party rights</li>
                <li>Your User Content</li>
              </ul>
            </section>

            <section className="content-section">
              <h2>10. Termination</h2>
              <p>
                We reserve the right to suspend or terminate your account and access to the Service at 
                any time, with or without notice, for any reason, including if we believe you have 
                violated these Terms.
              </p>
              <p>
                You may terminate your account at any time by contacting us or using the account 
                cancellation feature in your account settings.
              </p>
              <p>
                Upon termination, your right to use the Service will immediately cease, and we may delete 
                your account and all associated data.
              </p>
            </section>

            <section className="content-section">
              <h2>11. Governing Law and Dispute Resolution</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the 
                jurisdiction in which EnglishMaster is established, without regard to its conflict of 
                law provisions.
              </p>
              <p>
                Any disputes arising out of or relating to these Terms or the Service shall be resolved 
                through binding arbitration, except that either party may seek injunctive relief in court.
              </p>
            </section>

            <section className="content-section">
              <h2>12. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will notify you of any changes 
                by posting the new Terms on this page and updating the "Last updated" date.
              </p>
              <p>
                Your continued use of the Service after any changes constitutes your acceptance of the 
                new Terms. If you do not agree to the modified Terms, you must stop using the Service.
              </p>
            </section>

            <section className="content-section">
              <h2>13. Severability</h2>
              <p>
                If any provision of these Terms is found to be unenforceable or invalid, that provision 
                will be limited or eliminated to the minimum extent necessary, and the remaining 
                provisions will remain in full force and effect.
              </p>
            </section>

            <section className="content-section">
              <h2>14. Contact Information</h2>
              <p>
                If you have any questions about these Terms, please contact us at:
              </p>
              <div className="contact-info">
                <p><strong>Email:</strong> legal@englishmaster.com</p>
                <p><strong>Phone:</strong> +1 (234) 567-890</p>
                <p><strong>Address:</strong> 123 Learning Street, Education City, EC 12345</p>
              </div>
            </section>

            <section className="content-section acknowledgment">
              <p className="acknowledgment-text">
                BY USING THE SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS AND AGREE TO BE 
                BOUND BY THEM.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
